import React, { forwardRef } from "react";
import { BlockButton, RegularButton } from "./styled";

const HorizontalRadioButton = forwardRef(function HorizontalRadioButton(
  props,
  ref
) {
  const {
    index,
    appearance,
    value,
    selected,
    onClick,
    disabled = false,
    onKeyDown,
    selectedValue,
    onFocus,
    className,
  } = props;

  const Button =
    appearance === "horizontalBlocks" ? BlockButton : RegularButton;

  return (
    <Button
      ref={ref}
      role="radio"
      aria-checked={selected}
      className={className}
      tabIndex={selected ? 0 : !selectedValue && index === 0 ? 0 : -1}
      value={value}
      selected={selected}
      disabled={disabled}
      onKeyDown={(e) => onKeyDown(e, index)}
      onClick={onClick}
      onFocus={onFocus}
    >
      {props.children}
    </Button>
  );
});

export default HorizontalRadioButton;
